import type { AdminLanguage } from '@sirius/contracts/admin'
import { catalog as en } from '~/locales/en'

/** One language's catalog: nested keys, as `src/locales/<lang>/index.ts` merges them. */
export type Catalog = Record<string, unknown>

/**
 * `en` is bundled with the shell: it is every other language's fallback, and
 * the one a page shows before its own language has loaded. The others are
 * chunks of their own, fetched when a user's language is one of them. Each
 * loader names its module literally, or the build cannot split it (the
 * bundle guard, `bundle.unit.test.ts`, fails when `ru` or `tr` reach the
 * entry).
 */
export const EN_CATALOG: Catalog = en

export const CATALOG_LOADERS: Record<
  Exclude<AdminLanguage, 'en'>,
  () => Promise<Catalog>
> = {
  ru: async () => (await import('~/locales/ru')).catalog,
  tr: async () => (await import('~/locales/tr')).catalog,
}

export async function loadCatalog(language: AdminLanguage): Promise<Catalog> {
  return language === 'en' ? EN_CATALOG : CATALOG_LOADERS[language]()
}
